import { useMutation } from '@tanstack/react-query';
import { HcpSwitchoverApi } from '../../../apis/HcpSwitchoverApi/HcpSwitchoverApi.ts';
import { AppMedError } from '../../../error/AppMedError.ts';
import { IHcpSwitchoverBatch, IHcpSwitchoverCandidate } from '../HcpSwitchover.ts';

export const useHcpSwitchoverDryRun = () =>
    useMutation<IHcpSwitchoverCandidate[], AppMedError, IHcpSwitchoverBatch>({
        mutationFn: (batch) => HcpSwitchoverApi.dryRun(batch),
    });
